module.exports = __webpack_public_path__ + "img/1_icn_sneaker.6db4d5b0.png";